import type {NavigateFunction} from 'react-router';

import NiceModal from '@ebay/nice-modal-react';

import type {ConferenceApiModel} from '@yourcoach/shared/api/conference';
import type {CourseApiModel} from '@yourcoach/shared/api/course';
import type {MaybeExpanded} from '@yourcoach/shared/api/types';

import {isCancelCommand} from '@yourcoach/shared/services/entity-action/utils';
import {getConferenceActions} from '@yourcoach/shared/utils/entity/conference';
import {isChatConference} from '@yourcoach/shared/utils/entity/conference/isChatConference';
import {isPhoneConference} from '@yourcoach/shared/utils/entity/conference/isPhoneConference';

import type {ResolveType} from '@src/v2/modules/conference-preview';

import {buildConferenceRouteState} from '@src/routes/misc/conferenceRouteState';
import {routerPath} from '@src/routes/path';
import {ConferencePreviewModal} from '@src/v2/modules/conference-preview';

type Props = ConferenceApiModel & {
  course?: MaybeExpanded<CourseApiModel>;
};

export const joinConference = async (
  conference: Props,
  navigate: NavigateFunction,
) => {
  const isChat = isChatConference(conference);

  if (isChat) {
    const channelId = conference.course?.channel_ids[0];

    if (!channelId) {
      return;
    }

    const path = routerPath.chats.$buildPath({
      searchParams: {
        cid: channelId,
      },
    });

    navigate(path);

    return;
  }

  if (isPhoneConference(conference)) {
    const path = routerPath.phoneConference.$buildPath({
      params: {
        conferenceId: conference._id,
      },
    });

    navigate(path, {state: buildConferenceRouteState()});

    return;
  }

  const isStart = getConferenceActions(conference).includes('start');

  const result: ResolveType = await NiceModal.show(ConferencePreviewModal, {
    isStart,
  });

  if (isCancelCommand(result)) {
    return;
  }

  const {isAudioEnabled, isVideoEnabled} = result;

  const path = routerPath.conferenceV2.$buildPath({
    params: {
      conferenceId: conference._id,
    },
    searchParams: {
      a: isAudioEnabled ? '1' : '0',
      v: isVideoEnabled ? '1' : '0',
    },
  });

  navigate(path, {state: buildConferenceRouteState()});
};
